export const executeCallbacksOnEnterSpaceClick = (cbs, e) => {
  if (e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32 || e.type === 'click') {
    cbs.forEach((cb) => cb(e))
  }
}
